import { useEffect } from 'react';
import { HeadWrapper, Wrapper, Head, Title } from './admin-appeals-page.styles';
import { Typography } from '@shared/ui/typography/typography';
import { Button, Tabs } from '@vtbhome/juicyfront';
import { ArrowsChevronLeft } from '@vtbhome/juicyfront/indexIcon';
import { useHistory } from 'react-router-dom';
import { useUrlTabs } from '@shared/lib/hooks/use-url-tabs/use-url-tabs';
import { AdminAppealsPageTabs } from '../config/constants';
import { ListAdminFeedbackRequests } from '@widgets/list-admin-feedback-requests/ui/list-admin-feedback-requests';
import { FeedbackRequestListDataRequest } from '@entities/feedback-request/api/feedback-request-types';
import { useFeedbackRequestListSharedQuery } from '@entities/feedback-request/libs/hooks/use-feedback-request-list-shared-query/use-feedback-request-list-shared-query';
import { DEFAULT_FEEDBACK_REQUESTS_LIST_PARAMETERS } from '@entities/feedback-request/config/store-constants';
import { ListAdminFeedbackSubjects } from '@widgets/list-admin-feedback-subjects/ui/list-admin-feedback-subjects';
import { FeedbackSubjectListDataRequest } from '@entities/feedback-subject/api/feedback-subject-types';
import { useFeedbackSubjectListSharedQuery } from '@entities/feedback-subject/libs/hooks/use-feedback-subject-list-shared-query/use-feedback-subject-list-shared-query';
import { FilterFeedbackSubjects } from '@features/feedback-subject/filter-feedback-subject/ui/filter-feedback-subject';
import { FilterFeedbackRequests } from '@features/feedback-request/filter-feedback-request/ui/filter-feedback-request';
import { FeedbackRequestDownload } from '@features/feedback-request/feedback-request-download/ui/feedback-request-download';
import { DEFAULT_FEEDBACK_SUBJECTS_LIST_PARAMETERS } from '@entities/feedback-subject/config/store-constants';
import { CreateFeedbackSubject } from '@features/feedback-subject/mutate-feedback-subject/ui/create-feedback-subject';
import { useSearchParams } from '@shared/lib/hooks/use-search-params/use-search-params';

export const AdminAppealsPage = () => {
    const history = useHistory();

    const { tabValue, handleSetTabValue } = useUrlTabs({
        searchUrlKey: 'tab',
        tabValues: Object.values(AdminAppealsPageTabs),
        initialTabValue: AdminAppealsPageTabs.Appeals,
    });

    const [feedbackRequestsListParameters, setFeedbackRequestsListParameters] =
        useSearchParams<FeedbackRequestListDataRequest>({
            ...DEFAULT_FEEDBACK_REQUESTS_LIST_PARAMETERS,
            ...(history.location.state || {}),
        });
    const [feedbackSubjectListParameters, setFeedbackSubjectListParameters] =
        useSearchParams<FeedbackSubjectListDataRequest>(DEFAULT_FEEDBACK_SUBJECTS_LIST_PARAMETERS);

    const [getFeedbackRequestsList] = useFeedbackRequestListSharedQuery(feedbackRequestsListParameters);
    const [getFeedbackSubjectList] = useFeedbackSubjectListSharedQuery(feedbackSubjectListParameters);

    useEffect(() => {
        getFeedbackRequestsList(feedbackRequestsListParameters);
    }, [feedbackRequestsListParameters]);

    useEffect(() => {
        getFeedbackSubjectList(feedbackSubjectListParameters);
    }, [feedbackSubjectListParameters]);

    return (
        <Wrapper>
            <HeadWrapper>
                <Head>
                    {Boolean(history.length) && (
                        <Button
                            round
                            size='xl'
                            buttonType='secondary'
                            startAdornment={<ArrowsChevronLeft />}
                            onClick={() => history.goBack()}
                        />
                    )}
                    <Title size='h6'>Обращения</Title>
                    {tabValue === AdminAppealsPageTabs.Appeals && (
                        <FilterFeedbackRequests
                            feedbackRequestsListParameters={feedbackRequestsListParameters}
                            setFeedbackRequestsListParameters={setFeedbackRequestsListParameters}>
                            <FeedbackRequestDownload feedbackRequestsListParameters={feedbackRequestsListParameters} />
                        </FilterFeedbackRequests>
                    )}
                    {tabValue === AdminAppealsPageTabs.Subjects && (
                        <FilterFeedbackSubjects
                            feedbackSubjectsListParameters={feedbackSubjectListParameters}
                            setFeedbackSubjectsListParameters={setFeedbackSubjectListParameters}>
                            <CreateFeedbackSubject />
                        </FilterFeedbackSubjects>
                    )}
                </Head>
            </HeadWrapper>
            <Tabs
                size='sm'
                list={[
                    {
                        label: <Typography size='body1_long'>Все обращения</Typography>,
                        tab: (
                            <ListAdminFeedbackRequests
                                feedbackRequestsListParameters={feedbackRequestsListParameters}
                                setFeedbackRequestsListParameters={setFeedbackRequestsListParameters}
                            />
                        ),
                        active: tabValue === AdminAppealsPageTabs.Appeals,
                        handler: () => handleSetTabValue(AdminAppealsPageTabs.Appeals),
                    },
                    {
                        label: <Typography size='body1_long'>Темы обращений</Typography>,
                        tab: (
                            <ListAdminFeedbackSubjects
                                feedbackSubjectsListParameters={feedbackSubjectListParameters}
                                setFeedbackSubjectsListParameters={setFeedbackSubjectListParameters}
                            />
                        ),
                        active: tabValue === AdminAppealsPageTabs.Subjects,
                        handler: () => handleSetTabValue(AdminAppealsPageTabs.Subjects),
                    },
                ]}
            />
        </Wrapper>
    );
};
